import type { AdminNamespace } from '@cli-types/next-adapter/config.js'

export function replaceAdminCamelToken(value: string, namespace: AdminNamespace): string {
  return value.replace(/\badmin(?=[A-Z])/g, namespace.camel)
}
